import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Layout from "@/components/Layout";
import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";

const ROLES = [
  "Stand-Up Comedian",
  "Professional Wrestling Manager & Promoter",
  "Show Producer",
];

export default function AboutPage() {
  return (
    <Layout padTop>
      <Seo
        title="About James R. Hustle | Hustle Promotions"
        description="James R. Hustle is a stand-up comedian, professional wrestling manager and promoter, and show producer, and the founder of Hustle Promotions."
      />

      <section data-testid="about-hero" style={{ background: "var(--black)" }}>
        <div className="container-editorial section-pad">
          <div className="split-hero" style={{ alignItems: "stretch" }}>
            {/* TEXT */}
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <Reveal>
                <p className="eyebrow" style={{ marginBottom: "1.5rem" }}>About</p>
              </Reveal>
              <Reveal delay={80}>
                <h1 className="h-page" data-testid="about-h1" style={{ maxWidth: "12ch" }}>
                  James R. Hustle
                </h1>
              </Reveal>

              <Reveal delay={140}>
                <div className="spec-grid" data-testid="about-roles" style={{ marginTop: "2rem", maxWidth: "34rem" }}>
                  {ROLES.map((r) => (
                    <div className="spec-item" key={r}>
                      <span className="spec-mark">—</span>
                      <span className="spec-text">{r}</span>
                    </div>
                  ))}
                </div>
              </Reveal>

              <Reveal delay={200}>
                <p className="body-lg" data-testid="about-bio" style={{ marginTop: "2.25rem", maxWidth: "56ch" }}>
                  James R. Hustle has spent years working both in front of live audiences and behind the
                  scenes producing professional wrestling and stand-up comedy shows. His experience in
                  both industries gives Hustle Promotions direct access to performers and firsthand
                  knowledge of what it takes to put together a successful show.
                </p>
              </Reveal>

              <Reveal delay={260}>
                <div style={{ marginTop: "2.5rem" }}>
                  <Link to="/book" className="btn btn-solid" data-testid="about-book-cta">
                    Book A Show <ArrowRight size={16} strokeWidth={2} />
                  </Link>
                </div>
              </Reveal>
            </div>

            {/* OWNER IMAGE SLOT — swap wrestling-mic.jpg for a future championship-belt photo here */}
            <Reveal delay={120}>
              <div className="media-frame media-tall" data-testid="about-owner-image">
                <img
                  src="/assets/wrestling-mic.jpg"
                  alt="James R. Hustle holding a microphone in the ring under stage haze, black and white"
                  className="img-cover"
                  style={{ objectPosition: "50% 35%" }}
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </Layout>
  );
}
